import styled, { css } from 'styled-components'
import { IconV2 } from 'ui/components'

export const Section = styled.section<{ $face: 'solid' | 'outlined' }>`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${(p) =>
    p.$face === 'solid' &&
    css`
      border-radius: 12px;
      box-shadow: var(--theme-boxShadows-offset-offset100Y4);
    `}
`

export const Content = styled.div<{ $hasPaddings: boolean }>`
  ${(p) =>
    p.$hasPaddings &&
    css`
      padding-top: 28px;
      padding-bottom: 60px;
      padding-left: 50px;
      padding-right: 50px;
    `}
`

export const TitleWrap = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  font: var(--theme-typography-h3-regular);
`

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  margin-left: auto;
`

const HeaderBase = styled.div<{ $foldable: boolean; $expanded: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: ${({ $foldable }) => ($foldable ? 'pointer' : 'default')};
  padding-left: 50px;
  padding-right: 50px;
  min-height: 56px;
  position: relative;
`

export const HeaderSolid = styled(HeaderBase)`
  background: var(--theme-colors-global-grey-grey300);
`

export const HeaderOutlined = styled(HeaderBase)`
  background: transparent;
  border-bottom: 1px solid var(--theme-colors-global-grey-grey300);
`

export const ToggleIcon = styled(IconV2)`
  position: absolute;
  left: 17px;
`
